import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { changeCollapsedForm, changeHiddenForm, changeActiveItem } from '@redux/sidebar/sidebar_slice';
import LogoutModal from '../../LogoutModal/LogoutModal';
import SidebarItem from './SidebarItem';
import './sidebar.scss';

// import all static icons
import transactionIcon from '@icons/transaction-icon.svg';
import parkers from '@icons/parker-inactive.svg';
import reportIcon from '@icons/report-icon.svg';
// import lprIcon from '@icons/lpr-icon.svg';
import logoutIcon from '@icons/logout-icon.svg';
import userCircle from '@icons/profile-circle.svg';
import redLogout from '@icons/logout-red.svg';
import locationIcon from '@icons/location-icon.svg';
import groupIcon from '@icons/group-inactive.svg';
import eventIcon from '@icons/inactive-calendar.svg';
import promotionIcon from '@icons/promotion-inactive.svg';
import validateIcon from '@icons/validate-icon.svg';
import billingIcon from '@icons/billing-icon.svg';
import lprIconPng from '@icons/lpr-icon.png';
import { useDispatch, useSelector } from 'react-redux';

// Import all light frame icons
import homeIcon from '@icons/home-2.svg';
import dashboardIcon from '@icons/dashboard-light-icon.svg';
import paymentIcon from '@icons/Frame 1321314704.svg'; // Locations
import parkerLocationIcon from '@icons/Frame 1321314705.svg'; // Subscriptions
import supportIcon from '@icons/Frame 1321314707.svg'; // Payments
import accountIcon from '@icons/Frame 1321314777.svg'; // Vehicles
import vehicleIcon from '@icons/Frame 1321314702.svg'; // Support
import subscriptionIcon from '@icons/money-time.svg'; // Account Settings subscriptionIcon accountIcon
import manageIcon from '@icons/Manage - Gray.svg';
import { logoutUser } from '../../../redux/auth/auth_slice';
const Sidebar = () => {
    //state to handle the modal
    const [showLogoutModal, setLogoutModal] = useState(false);
    const handleLogoutModal = () => setLogoutModal((pre) => !pre);
    const { userInfo } = useSelector((state) => state.auth);

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [sideBarItems, setSidebarItems] = useState([]);
    const [bottomItems, setBottomItems] = useState([]);
    const {
        transitionType,
        collapsedForm,
        hiddenForm,
        activeItem,
        url: activeUrl
    } = useSelector((state) => state.sidebar);
    const userPermissions = useSelector((state) => state.auth.permissions);

    const adminSideBarItemsCopy = [
        {
            id: 999,
            name: 'Manage',
            iconLight: manageIcon,
            access: ['admin', 'operator'],
            type: 'MainItem',
            allowedLinks: ['/admin/', '/admin/groups', '/admin/event-rates', '/admin/promotions'],
            subItems: [
                {
                    id: 1,
                    name: 'Locations',
                    iconLight: locationIcon,
                    linkTo: '/admin/',
                    access: ['admin', 'operator'],
                    permissionKey: 'locations'
                },
                // Operator-specific items
                {
                    id: 4,
                    name: 'Groups',
                    iconLight: groupIcon,
                    linkTo: '/admin/groups',
                    access: ['admin', 'operator'],
                    permissionKey: 'groups'
                },
                {
                    id: 5,
                    name: 'Event Rates',
                    iconLight: eventIcon,
                    linkTo: '/admin/event-rates',
                    access: ['admin']
                },
                {
                    id: 6,
                    name: 'Promotions',
                    iconLight: promotionIcon,
                    linkTo: '/admin/promotions',
                    access: ['admin']
                }
            ]
        },

        {
            id: 10,
            name: 'Report',
            iconLight: reportIcon,
            access: ['admin', 'operator'],
            type: 'MainItem',
            allowedLinks: [
                '/admin/reports',
                '/admin/transactions',
                '/admin/parkers',
                '/admin/subscriptions',
                '/admin/parker-payments',
                '/admin/lpr'
            ],
            subItems: [
                {
                    id: 2,
                    name: 'Transactions',
                    iconLight: transactionIcon,
                    linkTo: '/admin/transactions',
                    access: ['admin', 'operator'],
                    // Assume transactions rely on the "payments" permission
                    permissionKey: 'payments'
                },
                {
                    id: 3,
                    name: 'Parkers',
                    iconLight: parkers,
                    linkTo: '/admin/parkers',
                    access: ['admin', 'operator'],
                    permissionKey: 'parkers'
                },

                {
                    id: 8,
                    name: 'Subscriptions',
                    iconLight: subscriptionIcon,
                    linkTo: '/admin/subscriptions',
                    access: ['admin', 'operator'],
                    permissionKey: 'subscriptions'
                },
                {
                    id: 9,
                    name: 'Parker Payments',
                    iconLight: transactionIcon,
                    linkTo: '/admin/parker-payments',
                    access: ['admin']
                },

                {
                    id: 11,
                    name: 'LPR',
                    iconLight: lprIconPng,
                    linkTo: '/admin/lpr',
                    access: ['admin', 'operator'],
                    permissionKey: 'lpr'
                }
            ]
        },

        {
            id: 12,
            name: 'Settings',
            iconLight: accountIcon,
            linkTo: '/admin/account-settings',
            access: ['operator']
            // No specific permission key needed – assume operators always have account settings access
        },
        {
            id: 13,
            name: 'Logout',
            iconLight: logoutIcon,
            access: ['admin', 'operator']
        }
    ];

    // Updated adminSideBarItems with access control
    const adminSideBarItems = [
        {
            id: 1,
            name: 'Locations',
            iconLight: locationIcon,
            linkTo: '/admin/',
            access: ['admin', 'operator'],
            permissionKey: 'locations'
        },
        {
            id: 2,
            name: 'Transactions',
            iconLight: transactionIcon,
            linkTo: '/admin/transactions',
            access: ['admin', 'operator'],
            // Assume transactions rely on the "payments" permission
            permissionKey: 'payments'
        },
        {
            id: 3,
            name: 'Parkers',
            iconLight: parkers,
            linkTo: '/admin/parkers',
            access: ['admin', 'operator'],
            permissionKey: 'parkers'
        },
        // Operator-specific items
        {
            id: 4,
            name: 'Groups',
            iconLight: groupIcon,
            linkTo: '/admin/groups',
            access: ['admin', 'operator'],
            permissionKey: 'groups'
        },
        {
            id: 5,
            name: 'Event Rates',
            iconLight: eventIcon,
            linkTo: '/admin/event-rates',
            access: ['admin']
        },
        {
            id: 6,
            name: 'Promotions',
            iconLight: promotionIcon,
            linkTo: '/admin/promotions',
            access: ['admin']
        },
        {
            id: 8,
            name: 'Subscriptions',
            iconLight: subscriptionIcon,
            linkTo: '/admin/subscriptions',
            access: ['admin', 'operator'],
            permissionKey: 'subscriptions'
        },
        {
            id: 9,
            name: 'Parker Payments',
            iconLight: transactionIcon,
            linkTo: '/admin/parker-payments',
            access: ['admin']
        },
        {
            id: 10,
            name: 'Report',
            iconLight: reportIcon,
            linkTo: '/admin/reports',
            access: ['admin']
        },
        {
            id: 11,
            name: 'LPR',
            iconLight: lprIconPng,
            linkTo: '/admin/lpr',
            access: ['admin', 'operator'],
            permissionKey: 'lpr'
        },
        {
            id: 12,
            name: 'Settings',
            iconLight: accountIcon,
            linkTo: '/admin/account-settings',
            access: ['operator']
            // No specific permission key needed – assume operators always have account settings access
        },
        {
            id: 13,
            name: 'Logout',
            iconLight: logoutIcon,
            access: ['admin', 'operator']
        }
    ];

    const userSideBarItems = [
        {
            id: 1,
            name: 'Home',
            iconLight: homeIcon,
            linkTo: '/parker/'
        },
        {
            id: 2,
            name: 'Locations',
            iconLight: parkerLocationIcon,
            linkTo: '/parker/locations'
        },
        {
            id: 3,
            name: 'Subscriptions',
            iconLight: subscriptionIcon,
            linkTo: '/parker/subscriptions'
        },
        {
            id: 4,
            name: 'Payments',
            iconLight: paymentIcon,
            linkTo: '/parker/payments'
        },
        {
            id: 5,
            name: 'Vehicles',
            iconLight: vehicleIcon,
            linkTo: '/parker/vehicles'
        },
        {
            id: 6,
            name: 'Support',
            iconLight: supportIcon,
            linkTo: '/parker/support'
        }
        // Removed 'Account Settings' from main items
    ];
    const userBottomItems = [
        {
            id: 7,
            name: 'Settings',
            iconLight: accountIcon,
            linkTo:
                userInfo?.role === 'GROUP_ADMIN' || userInfo?.role === 'GROUP_STAFF'
                    ? '/group-admin/account-settings'
                    : '/parker/account-settings'
        }
        // You can add more bottom items if needed
    ];

    // Define group admin sidebar items
    const groupAdminSidebarItems = [
        {
            id: 1,
            name: 'Dashboard',
            iconLight: dashboardIcon,
            linkTo: '/group-admin',
            access: ['group-admin', 'group-staff'],
            permissionKey: 'dashboard'
        },
        {
            id: 2,
            name: 'Subscriptions',
            iconLight: subscriptionIcon,
            linkTo: '/group-admin/subscriptions',
            access: ['group-admin', 'group-staff'],
            permissionKey: 'subscriptions'
        },
        {
            id: 3,
            name: 'Validations',
            iconLight: validateIcon,
            linkTo: '/group-admin/validate',
            access: ['group-admin', 'group-staff'],
            permissionKey: 'validations'
        },
        {
            id: 4,
            name: 'Billing',
            iconLight: billingIcon,
            linkTo: '/group-admin/billing',
            access: ['group-admin', 'group-staff'],
            permissionKey: 'payments'
        },

        {
            id: 5,
            name: 'Logout',
            iconLight: logoutIcon
        }
    ];

    const handleSideBarClick = (item) => {
        if (item.name === 'Logout') {
            handleLogoutModal();
            dispatch(changeActiveItem({ activeItem: 1, url: item.linkTo })); // Dispatch the selected item to update the activeLink
        } else {
            dispatch(changeActiveItem({ activeItem: item.id, url: item.linkTo })); // Dispatch the selected item to update the activeLink
            //if the sidebar is not collapsed or hidden on mobile screens, the sidebar will auto close on the nav click
            if (window.screen.width < 768) {
                dispatch(changeHiddenForm(true));
            } else if (window.screen.width > 768 && window.screen.width < 992 && !collapsedForm) {
                dispatch(changeCollapsedForm(true));
            }
            navigate(item.linkTo); // Navigate to the new route
        }
    };

    useEffect(() => {
        const { role } = userInfo || {};

        if (role === 'ADMIN') {
            setSidebarItems(adminSideBarItemsCopy);
            setBottomItems([]);
        } else if (role === 'OPERATOR') {
            // For operators, check if each item's permissionKey is allowed.
            const filteredItems = adminSideBarItemsCopy.filter((item) => {
                if (!item.access.includes('operator')) return false;
                if (item.permissionKey) {
                    // Ensure that operatorPermissions exists and the permission is set to true.
                    return userPermissions && userPermissions[item.permissionKey] === true;
                }
                return true;
            });
            setSidebarItems(filteredItems);
            setBottomItems([]);
        } else if (role === 'GROUP_ADMIN') {
            setSidebarItems(groupAdminSidebarItems);
            setBottomItems(userBottomItems);
        } else if (role === 'GROUP_STAFF') {
            const filteredItems = groupAdminSidebarItems.filter((item) => {
                // Ensure the item is meant for group-staff
                if (!item?.access?.includes('group-staff')) return false;
                // For items with a permissionKey that are NOT dashboard or account settings,
                // check if the userPermissions allow access.
                if (item.permissionKey && item.permissionKey !== 'dashboard' && item.permissionKey !== 'settings') {
                    return userPermissions && userPermissions[item.permissionKey] === true;
                }
                // Always allow dashboard and account settings
                return true;
            });
            setSidebarItems(filteredItems);
            setBottomItems(userBottomItems);
        } else {
            setSidebarItems(userSideBarItems);
            setBottomItems(userBottomItems);
        }

        return () => {
            setSidebarItems([]);
            setBottomItems([]);
        };
    }, [location.pathname, userInfo?.role, userPermissions]);

    const selectActiveItem = () => {
        const allItems = [...sideBarItems, ...bottomItems];
        // Determine the selected item based on the current route
        const activeItem = allItems.find((item) => location.pathname === item.linkTo);
        if (activeItem) {
            dispatch(changeActiveItem({ activeItem: activeItem.id, url: activeItem.linkTo }));
        }
    };

    useEffect(() => {
        selectActiveItem();
    }, [location.pathname, sideBarItems, bottomItems]);

    return (
        <>
            {transitionType === 'collapse/expand' && (
                <div className={`sidebar ${collapsedForm ? 'collapse-sidebar' : 'expand-sidebar'}`}>
                    <div className="sidebar-main">
                        {(userInfo?.role === 'GROUP_ADMIN' || userInfo?.role === 'GROUP_STAFF') && (
                            <div className="sidebar-user-info">
                                <div className="group-name">
                                    <h5>{userInfo?.groupName || userInfo?.firstName || userInfo?.name}</h5>
                                    {(userInfo?.streetAddress || userInfo?.streetAddress2) && (
                                        <div>
                                            {`${
                                                userInfo?.streetAddress
                                                    ? userInfo?.streetAddress.split(' ')[0]
                                                    : userInfo?.streetAddress2
                                            }${userInfo?.city ? `, ${userInfo?.city}` : ''}${userInfo?.state ? `, ${userInfo?.state}` : ''}${userInfo?.zipCode ? `, ${userInfo?.zipCode}` : ''}`}
                                        </div>
                                    )}
                                </div>
                                <hr style={{ color: '#F0EFEF', border: '1px solid #F0EFEF' }} />
                            </div>
                        )}
                        {sideBarItems.map((item) => (
                            <SidebarItem
                                key={item.id}
                                item={item}
                                selectedItemId={activeItem}
                                handleSideBarClick={handleSideBarClick}
                                activeUrl={activeUrl}
                            />
                        ))}
                    </div>
                    {(userInfo?.role === 'GROUP_ADMIN' || userInfo?.role === 'GROUP_STAFF') && (
                        <div className="sidebar-bottom">
                            {bottomItems.map((item) => (
                                <SidebarItem
                                    key={item.id}
                                    item={item}
                                    selectedItemId={activeItem}
                                    handleSideBarClick={handleSideBarClick}
                                />
                            ))}
                            <div className="sidebar-profile" onClick={() => handleSideBarClick({ name: 'Logout' })}>
                                <div className="profile-icon">
                                    {userInfo?.userIcon ? (
                                        <img src={userInfo?.userIcon} alt="User Icon" />
                                    ) : (
                                        <img src={userCircle} alt="user-circle" />
                                    )}
                                    {!collapsedForm && (
                                        <span className="profile-name">
                                            {userInfo?.firstName
                                                ? `${userInfo?.firstName} ${userInfo?.lastName}`
                                                : userInfo?.name}
                                        </span>
                                    )}
                                </div>
                                {!collapsedForm && (
                                    <div className="profile-info">
                                        <img src={redLogout} alt="Logout" />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <LogoutModal isOpen={showLogoutModal} handleModal={handleLogoutModal} />
                </div>
            )}

            <button onClick={() => dispatch(logoutUser())} hidden type="button" id="whole-app-logout">
                log out button
            </button>
            {transitionType === 'hide/show' && (
                <div className={`sidebar ${hiddenForm ? 'hide-sidebar' : 'show-sidebar'}`}>
                    <div className="sidebar-main">
                        {sideBarItems.map((item) => (
                            <SidebarItem
                                key={item.id}
                                item={item}
                                selectedItemId={activeItem}
                                handleSideBarClick={handleSideBarClick}
                            />
                        ))}
                    </div>
                    {(userInfo?.role === 'GROUP_ADMIN' || userInfo?.role === 'GROUP_STAFF') && (
                        <div className="sidebar-bottom">
                            {bottomItems.map((item) => (
                                <SidebarItem
                                    key={item.id}
                                    item={item}
                                    selectedItemId={activeItem}
                                    handleSideBarClick={handleSideBarClick}
                                />
                            ))}
                            <div className="sidebar-profile" onClick={() => handleSideBarClick({ name: 'Logout' })}>
                                <div className="profile-icon">
                                    {userInfo?.userIcon ? (
                                        <img src={userInfo?.userIcon} alt="User Icon" />
                                    ) : (
                                        <img src={userCircle} alt="user-circle" />
                                    )}
                                    {!collapsedForm && (
                                        <span className="profile-name">
                                            {userInfo?.firstName
                                                ? `${userInfo?.firstName} ${userInfo?.lastName}`
                                                : userInfo?.name}
                                        </span>
                                    )}
                                </div>
                                {!collapsedForm && (
                                    <div className="profile-info">
                                        <img src={redLogout} alt="Logout" />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <LogoutModal isOpen={showLogoutModal} handleModal={handleLogoutModal} />
                </div>
            )}
        </>
    );
};
export default Sidebar;
